import React, { useState, useEffect } from "react";
import { useQuery, useQueries } from 'react-query'
import { getResultsRSC, getUnits } from "data/Querys"
import Loader from 'components/general/Loader'
import { useViewport } from 'components/general/useViewPort'
import { getPhaseRSC, getLongPhaseRSC } from 'helpers/rsc'
import Referees from 'components/general/Referees'
import ProgressionRule from 'components/common/ProgressionRule'
import NotAvailable from 'components/common/NotAvailable'
//Results
import SrfResults from 'components/sports/srf/views/SrfResults'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const SrfContext = () => {
    const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const [key, setKey] = useState('results');
    let _phase = getPhaseRSC(mirs_rsc);
    let _longPhase = getLongPhaseRSC(mirs_rsc);
    var unitsFound = 0

    //DATA
    const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
        {
            queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase],
            queryFn: getUnits,
            //refetchInterval: 30000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );

    let queryArray = [];

    unitsData?.phase?.units.forEach((unit) => {

        queryArray.push({
            queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, _longPhase],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    const results = useQueries(queryArray);
    const isLoading = unitsLoading || results.some(result => result.isLoading)
    const isError = unitsError || results.some(result => result.isError)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }

    return (
        <>
            <div className='mirs-page-container'>
            {(_phase.indexOf("PREL") > -1)
                ?
                <ProgressionRule
                    key="progress-component"
                    data={results[0].data?.config}
                    filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
                />
                : ''
            }
            {results.map((res, index) => {
                if (res.data?.results?.items !== undefined)
                    unitsFound++
                return <SrfResults key={`results-component-${index}`} data={res.data} />
            })
            }
            <Referees
                key="referee-component"
                data={results[0].data?.results?.officials}
                config={{ header: "HeaderPanelOfJudges" }}
            />
            {unitsFound === 0
                ? <NotAvailable />
                : ''
            }
            </div>
        </>
    );
};

export default SrfContext;
